import christian from "../assets/png/logo-christian-dior-couture.webp";
import sword from "../assets/png/sword.webp";
import altelios from "../assets/png/altelios.webp";
import ajc from "../assets/png/ajc.webp";

export const experienceData = [
  {
    id: 1,
    img: ajc,
    company: "AJC Informatique",
    jobtitle: "Technicien maintenance informatique",
    startYear: "2013",
    endYear: "2016",
  },
  {
    id: 2,
    img: altelios,
    company: "GROUPE ALTELIOS TECHNOLOGY",
    jobtitle: "TECHNICIEN HARDWARE",
    startYear: "2016",
    endYear: "2018",
  },
  {
    id: 3,
    img: sword,
    company: "Sword Group",
    jobtitle: "Developpeur Frontend",
    startYear: "2019",
    endYear: "2021",
  },
  {
    id: 4,
    img: christian,
    company: "Christian Dior Couture",
    jobtitle: "Full Stack Developpeur",
    startYear: "2022",
    endYear: "Present",
  },
];
